import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import {
  convertBoostrapColorToACssVar,
  BootstrapColors,
} from '../utilities/boostrap-color-utilities';

@customElement('apt-panel-with-border')
export class PanelWithBorder extends LitElement {
  @property({ type: String })
  borderPosition: 'border-start' | 'border-top' = 'border-start';

  @property({ type: String })
  borderColor: BootstrapColors = 'primary';

  static override get styles() {
    return [
      css`
        .flex-container {
          min-height: 170px;
          margin-bottom: 10px;
          padding: 20px;
          background-color: var(--bs-white);
          border: 1px solid var(--bs-border-color);
          display: flex;
          flex-direction: row;
        }
      `,
    ];
  }

  generateStyles() {
    switch (this.borderPosition) {
      case 'border-start':
        return {
          'border-left': `5px solid var(${convertBoostrapColorToACssVar(
            this.borderColor,
          )})`,
        };

      case 'border-top':
        return {
          'border-top': `5px solid var(${convertBoostrapColorToACssVar(
            this.borderColor,
          )})`,
        };

      default:
        throw new Error(
          `Border position ${this.borderPosition} not supported out of the box, only border-start and border-top positions are. Please see bootstrap's border utilities for more info.`,
        );
    }
  }

  override render() {
    return html`
      <div
        class="flex-container border-5"
        style=${styleMap(this.generateStyles())}
      >
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-panel-with-border': PanelWithBorder;
  }
}
